<template>
  <div class="d-flex align-items-center">
    <StarIcon v-for="(star, idx) in fullStars" :key="`full-${idx}`" size="1x" class="star-filled" />
    <StarIcon
      v-for="(star, idx) in emptyStars"
      :key="`empty-${idx}`"
      size="1x"
      class="star-empty"
    />
    <span v-if="showLabel" class="ml-2 star-label"
      >({{ avgRating }} {{ avgRating === 1 ? 'star' : 'stars' }})</span
    >
  </div>
</template>

<script>
import { StarIcon } from 'vue-feather-icons'

export default {
  name: 'StarRating',

  components: {
    StarIcon
  },

  props: {
    rating: {
      type: [Number, String],
      default: 0
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    avgRating() {
      return Math.round(Number(this.rating))
    },

    fullStars() {
      return new Array(this.avgRating || 0).fill(0)
    },

    emptyStars() {
      return new Array(5 - (this.avgRating || 0)).fill(0)
    }
  }
}
</script>

<style scoped>
.star-filled {
  color: #fbbf24;
  fill: #fbbf24;
}

.star-empty {
  color: #d1d5db;
  fill: none;
}

.star-label {
  font-size: 0.875rem;
  color: #6c757d;
}
</style>
